<template>
    <div class="dropdown float-left">
        <button type="button" :disabled="computerEaseLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="computerEaseOptionDropDown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
            <i  style="display: none;" class="fa fa-spin fa-spinner text-grey-darkest computer-ease-loader" aria-hidden="true"></i>
            CE Options <i class="fa fa-caret-down mx-1"></i>
        </button>
        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="computerEaseOptionDropDown">
<!--            <button type="button" class="dropdown-item py-2" :disabled="!computerEaseProjectMapping || (computerEaseProjectMapping && computerEaseProjectMapping.direction === 'one-way-followup') || project.CE_job_no" @click.prevent.stop="pushProjectToVista">-->
<!--                Connect/Push to CE-->
<!--            </button>-->
            <button type="button" class="dropdown-item py-2" :disabled="!computerEaseProjectMapping || computerEaseProjectMapping && computerEaseProjectMapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectFromCE" >
                Sync from CE
            </button>


        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncCEJobConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncCEJobConfirmModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Vista Job.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('syncCEJobConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="syncJobFromCE()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncJobFromCEModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium" v-if="!syncFromCEStepTwo">This project is not synced with a ComputerEase Job</h5>
                        <h5 class="modal-title text-teal font-medium" v-else>WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncJobFromCEModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromCEStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the ComputerEase Job to sync this project with</label>
                                <div v-if="fetchingCEJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from ComputerEase...
                                </div>
                                <multiselect
                                    v-model="selectedCEJob"
                                    :options="jobsFromCE"
                                    @search-change="onSyncCEInput"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search ComputerEase job by number or address..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromCEModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedCEJob" @click.prevent="() => syncFromCEStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the ComputerEase Job.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromCEModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedCEJob" @click.prevent="syncJobFromCE">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'project-computerEase',
    components: {Multiselect},
    props: ['project', 'computerEaseAccess', 'projectSalesStatusState', 'computerEaseProjectMapping'],
    data() {
        return {
            selectedCEJob: null,
            jobsFromCE: [],
            syncFromCEStepTwo: false,
            fetchingCEJobs: false,
            computerEaseLoading: false,
            projectContacts: []
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
    },
    mounted() {

        $(document).ready(function() {
            // Initialize tooltip
            $('.custom-tooltip').tooltip();
        });
    },
    methods: {
        syncProjectFromCE(){
            if(this.project.CE_job_no){
                $('#syncCEJobConfirmModal').modal('show');
            }else{
                $('#syncJobFromCEModal').modal('show');
            }
        },
        openModal(modalId) {
            $('#'+modalId).modal('show');
            if(modalId === 'vistaCustomerSelectionModal'){
                this.selectedCustomerForVistaJob = null;
            }
            $('.computer-ease-loader').show();
            // if(modalId === 'vistaDepartmentAndLiabTemplateModal'){
            //     this.fetchVistaDepartmentAndLiabTemplate();
            // }
        },
        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            $('.computer-ease-loader').hide();
        },
        onSyncCEInput(value) {
            if (value.length >= 1) {
                this.fetchingCEJobs = true;
                this.debouncedFilterOptions(value);
            }
        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.project.ce.search-job-from-ce'), {search: input}).then((response) => {
                self.fetchingCEJobs = false;
                if(response.data.status == 'success'){
                    self.jobsFromCE = response.data.computerEaseJobs;
                    self.jobsFromCE = self.jobsFromCE.map((job) => {
                        let label = job.code + ' | ' + job.description
                        return {
                            ...job,
                            "label": label
                        }
                    })
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        syncJobFromCE(){
            let self = this;
            $('.computer-ease-loader').show();
            let data = {
                projectId: this.project.id,
                CEJob: this.selectedCEJob ?? null
            }
            axios.post(route('api.project.ce.sync-project-from-ce'), data).then((response) => {
                $('.computer-ease-loader').hide();
                if(response.data.status == 'success'){

                    self.closeModal('syncCEJobConfirmModal');
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },

    }

}
</script>
<style scoped>
.custom-tooltip{
    pointer-events: all !important;
}
</style>
